import React from 'react';

/** Official Town icon (the B set in a landscape), gold on transparent. */
const ICON_SRC = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/06/Bonnyville_Icon_Gold_RGB.png';
/** Horizontal gold-and-white signature, for the dark grounds. */
const LIGHT_SRC = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/06/Logo-Yellow-and-White.png';
interface LogoProps {
  className?: string;
  variant?: 'color' | 'light' | 'icon';
}
export function Logo({
  className = '',
  variant = 'color'
}: LogoProps) {
  if (variant === 'icon') {
    return <span className={`inline-flex items-center ${className}`} data-id="element-1364" data-mp="rpux6jndn86i">
        <img src={ICON_SRC} width={438} height={490} alt="Town of Bonnyville" className="h-[42px] w-auto shrink-0" data-id="element-1365" data-mp="dr4r4eikxy60" />
      </span>;
  }
  if (variant === 'light') {
    return <span className={`inline-flex items-center ${className}`} data-id="element-1366" data-mp="2yin93wuotm1y">
        <img src={LIGHT_SRC} width={694} height={192} alt="Town of Bonnyville" className="h-[52px] w-auto shrink-0" data-id="element-1367" data-mp="2ykhybnczs0bu" />
      </span>;
  }
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-1368" data-mp="1euhtw07ypu8w">
      <img src={ICON_SRC} width={438} height={490} alt="" aria-hidden="true" className="h-[46px] w-auto shrink-0" data-id="element-1369" data-mp="1ewukf1rsdcxk" />
      <span className="flex flex-col leading-none" data-id="element-1370" data-mp="1nvg2kvtcipxt">
        <span className="font-display text-[21px] font-extrabold tracking-tight text-ville-navy" data-id="element-1371" data-mp="1nx98ua01r85a">Bonnyville</span>
        <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-ville-blue" data-id="element-1372" data-mp="1jw77nnmkkm0o">
          North of Expected
        </span>
        <span className="sr-only" data-id="element-1373" data-mp="1svatv0h19hje">Town of Bonnyville</span>
      </span>
    </span>;
}